import "./sentry";
import { Howler } from "howler";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

// Reload when Vite fails to load a preloaded module chunk (e.g. after a deploy
// invalidates old chunk hashes). Complements the retry logic in lazyWithRetry.
window.addEventListener("vite:preloadError", () => {
  window.location.reload();
});

// Prevent Howler from suspending the AudioContext when the page loses focus,
// which would cut off audio mid-experience on desktop.
Howler.autoSuspend = false;

// iOS suspends the AudioContext until a user gesture, and can re-suspend it
// when the app is backgrounded. Resume on every pointer/touch event to cover
// both the initial unlock and any subsequent re-suspensions.
function resumeAudioContext() {
  if (Howler.ctx?.state === "suspended") {
    Howler.ctx.resume();
  }
}
window.addEventListener("pointerdown", resumeAudioContext);
window.addEventListener("touchstart", resumeAudioContext);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
